import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from "../../config";

// Sign in is by email now. `username` was a second unique identity column
// beside email, so there were two ways to collide and two things to remember;
// the backend still accepts a `username` field and treats it as the address,
// which is what keeps an older cached bundle working.
//
// This component also used to call `onLogin(res.data)` while App's handler had
// the signature (username, password) and did its own POST — so a successful
// sign-in fired a second, malformed login request. App now just takes the
// result.

export default function Login({ onLogin }) {
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setSubmitting(true);
        try {
            const res = await fetch(`${API_BASE_URL}/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });
            const data = await res.json().catch(() => ({}));

            if (!res.ok) {
                setError(data.message || 'Sign in failed.');
                setSubmitting(false);
                return;
            }

            localStorage.setItem('token', data.token);
            localStorage.setItem('username', data.display_name || '');
            localStorage.setItem('role', data.active_role || data.role || '');
            localStorage.setItem('roles', JSON.stringify(data.roles || []));
            localStorage.setItem('vendor_id', data.vendor_id || '');
            localStorage.setItem('customer_id', data.customer_id || '');

            if (onLogin) onLogin(data);

            navigate(
                (data.active_role || data.role) === 'vendor'
                    ? '/vendor-dashboard'
                    : '/devices'
            );
        } catch {
            setError('Network error. Please try again.');
            setSubmitting(false);
        }
    }

    return (
        <div className="wb-page wb-page--narrow">
            <h1>Sign in</h1>

            <form onSubmit={handleSubmit} className="wb-card">
                <label className="wb-field">
                    <span className="wb-label">Email</span>
                    <input
                        className="wb-input" name="email" type="email" autoComplete="email"
                        value={form.email} onChange={handleChange} required autoFocus
                    />
                </label>

                <label className="wb-field">
                    <span className="wb-label">Password</span>
                    <input
                        className="wb-input" name="password" type="password"
                        autoComplete="current-password"
                        value={form.password} onChange={handleChange} required
                    />
                </label>

                <button
                    type="submit"
                    className="wb-btn wb-btn--primary wb-btn--block"
                    disabled={submitting}
                >
                    {submitting ? 'Signing in…' : 'Sign in'}
                </button>

                {error && <div className="wb-note wb-note--danger" style={{ marginTop: '1rem' }}>{error}</div>}
            </form>

            <p className="wb-sub" style={{ marginTop: '1.5rem' }}>
                <Link to="/forgot-password">Forgotten your password?</Link>
            </p>
            <p className="wb-sub">
                No account yet? <Link to="/register/customer">Advertise</Link> or{' '}
                <Link to="/register/vendor">list a screen</Link>.
            </p>
        </div>
    );
}
